import React, {useState, useContext} from "react";
import './LogOut.css'
import {useNavigate} from "react-router-dom";
import {FaRegUserCircle} from "react-icons/fa";
import {authAPI} from "../../../../api/authApi";
import ConfirmDialog from "../../../../components/UI/ConfirmDialog/ConfirmDialog";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/UI/Button/Button";
import AuthContext from "../../../../context/AuthContext";

const LogOut = ({setActiveTab}) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { setUser } = useContext(AuthContext);
    const lang = i18n.language;

    // ==================== STATE ====================
    const [confirmDialog, setConfirmDialog] = useState(null);

    // CONFIRM DIALOG
    const showConfirmDialog = (action, message) => {
        setConfirmDialog({action, message, isOpen: true});
    };

    const handleConfirmDialog = async (confirmed) => {
        if (confirmed && confirmDialog.action === 'logout') {
            await performLogout();
        }
        setConfirmDialog(null);
    };

    //LOGOUT
    const performLogout = async () => {
        try {
            await authAPI.logout();
        } catch (err) {
            console.error('Logout error:', err);
        } finally {
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            setUser({ _id: '', name: '', email: '' });
            navigate(`/${lang}/sign-in`);
        }
    };

    const handleLogoutClick = () => {
        showConfirmDialog('logout', t('profilePage.logoutConfirm'));
    };


    return (
       <>
           {/* Confirm Dialog */}
           {confirmDialog?.isOpen && (
               <ConfirmDialog
                   message={confirmDialog.message}
                   onConfirm={() => handleConfirmDialog(true)}
                   onCancel={() => handleConfirmDialog(false)}
               />
           )}

           <div className='profile-logout-section'>

               <div className='profile-logout-icon'>
                   <FaRegUserCircle/>
               </div>
               <h2 className='profile-logout-title'>{t('profilePage.areYouSure')}</h2>
               <p className='profile-logout-message'>{t('profilePage.logoutConfirm')}</p>
               <div className='profile-actions'>
                   <button
                       className='profile-btn profile-btn-logout'
                       onClick={handleLogoutClick}
                   >
                       {t('profilePage.logout')}
                   </button>
                   <Button
                       type="button"
                       className='profile-btn'
                       onClick={() => setActiveTab('profile')}
                   >
                       {t('profilePage.cancel')}
                   </Button>
               </div>
           </div>
       </>
    );
}

export default LogOut;
